'use client';

import { useReportWebVitals } from 'next/web-vitals';

const API_URL = '/api/web-vitals';

export function WebVitals() {
  useReportWebVitals(metric => {
    const body = JSON.stringify(metric);

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (navigator.sendBeacon) {
      navigator.sendBeacon(API_URL, body);
    } else {
      fetch(API_URL, { body, method: 'POST', keepalive: true });
    }
  });

  return null;
}
